import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createUtilityType,
  deleteUtilityType,
  listUtilityTypes,
  toggleUtilityType,
  updateUtilityType,
} from '@/lib/utilities'

const KEY = ['utility-types'] as const

export function useUtilityTypes(enabled = true) {
  return useQuery({ queryKey: KEY, queryFn: listUtilityTypes, enabled })
}

export function useCreateUtilityType() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: createUtilityType,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export function useUpdateUtilityType() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Parameters<typeof updateUtilityType>[1] }) =>
      updateUtilityType(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export function useToggleUtilityType() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: toggleUtilityType,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export function useDeleteUtilityType() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: deleteUtilityType,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
